import style from '../CreditOnboardingEgyptLuckyV1/CreditOnboardingEgyptLuckyV1.css';
import TextField from '../../shared/TextField/TextField';
import Button from '../../shared/Button/Button';
import useTranslation from '../../../localization/i18n.context';
import Title from '../../shared/Typography/Title';
import { useState, useEffect } from 'preact/hooks';

const StepField = {
  EMPLOYER_NAME: 'employerName',
};

export default function EmployerStep({
  onInputChange,
  onButtonClick,
  data = {},
  stepNumber,
  stepCount,
}) {
  const [selectedValue, setSelectedValue] = useState(null);
  const { t } = useTranslation();
  const isButtonEnabled = Object.values(StepField).every(
    field => data[field] && data[field].value && data[field].value?.trim(),
  );

  useEffect(() => {
    updateSelectedValues(data);
  }, [data]);

  function updateSelectedValues(formData) {
    if (formData[StepField.EMPLOYER_NAME]) {
      setSelectedValue(formData[StepField.EMPLOYER_NAME].value ?? null);
    }
  }

  return (
    <main className={style.main}>
      <div className={style['form-content']}>
        <div className={style['form-header']}>
          <p className={style['form-header-title']}>
            {t(`STEP {step_number}/{step_count}`, {
              '{step_number}': stepNumber,
              '{step_count}': stepCount,
            })}
          </p>
        </div>
        <div className={style['form-title']}>
          <Title text={t(`What's the name of your current employer?`)} />
        </div>
        <div className={style['form-inputs']}>
          <div className={style['form-control']}>
            <TextField
              label={t('Employer name')}
              placeholder={t('Enter name')}
              onInput={onInputChange}
              name={StepField.EMPLOYER_NAME}
              value={selectedValue}
            />
          </div>
        </div>
      </div>
      <div className="fixed-cta">
        <Button fullWidth onClick={onButtonClick} disabled={!isButtonEnabled}>
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
EmployerStep.Type = 'EmployerStep';
EmployerStep.EventName = 'employer_step';
